/**
 * 资讯
 * add 2020-08-18 by tuanhui
 */

import Request from '../common/request';
import address from './address'

export default {
    //下载收据
    receiptDownload: (data) => Request.downloadFile(address.receiptDownload, data),
    //下载出席证明
    certificateDownload: (data) => Request.downloadFile(address.certificateDownload, data),
    getHomeInfos: (data) => Request.get(address.getHomeInfos, data),
    getAssociationDetail: (data) => Request.get(address.getAssociationDetail, data),
    //參加學會活動
    joinActivity: (data) => Request.post(address.joinActivity, data),
    //学会报名支付结果查询
    getPayResult: (data) => Request.post(address.getPayResult, data),
    //学会报名，重新支付
    rePayActivityCost: (data) => Request.post(address.rePayActivityCost, data),
    //学会网站登录协议勾选
    checkedProtocol: (data) => Request.post(address.checkedProtocol, data),
    //学术文化列表
    getArticleList: (data) => Request.get(address.getArticleList, data),
    //最新学术文化列表
    getNewArticleList: (data) => Request.get(address.getNewArticleList, data),
    //最热学术文化列表
    getHotArticleList: (data) => Request.get(address.getHotArticleList, data),
    //学术文化详情
    getArticleDetail: (data) => Request.get(address.getArticleDetail, data),
    //课程活动列表
    getActivityList: (data) => Request.get(address.getActivityList, data),
    //课程活动详情
    getActivityDetail: (data) => Request.get(address.getActivityDetail, data),
    //最近课程活动列表
    getNewActivityList: (data) => Request.get(address.getNewActivityList, data),
    //学会活动照片
    getActivityPhotos: (data) => Request.get(address.getActivityPhotos, data),
    //学会活动照片详情
    getActivityPhotoDetail: (data) => Request.get(address.getActivityPhotoDetail, data),
    //学会资讯列表
    getNewsList: (data) => Request.get(address.getNewsList, data),
    //学会资讯详情
    getNewsDetail: (data) => Request.get(address.getNewsDetail, data),
    //学会资讯分类列表
    getNewsCategoryList: (data) => Request.get(address.getNewsCategoryList, data),

    login: (data) => Request.post(address.login, data),
    logout: (data) => Request.post(`${address.logout}?clientId=${data.clientId}&token=${data.token}`, null),
    register: (data) => Request.post(address.register, data),
    getVCode: (data) => Request.post(`${address.getVCode}?codeType=${data.codeType}&phoneNumber=${data.phoneNumber}`, null),
    resetPassword: (data) => Request.post(`${address.resetPassword}?codeKey=${data.codeKey}&newPwd=${data.newPwd}&numcode=${data.numcode}&phone=${data.phone}`, null),
    updatePassword: (data) => Request.post(`${address.updatePassword}?clientId=${data.clientId}&newPwd=${data.newPwd}&oldPwd=${data.oldPwd}`, null),
    getUserInfo: (data) => Request.get(`${address.getUserInfo}?clientid=${data.clientId}`, null),

    joinAssociation: (data) => Request.post(`${address.joinAssociation}?associationid=${data.associationid}&clientid=${data.clientid}`, null),
    getAreaList: (data) => Request.get(address.getAreaList, data),
    getMyActivitys: (data) => Request.post(address.getMyActivitys, data),
    getActivityInfo: (data) => Request.post(address.getActivityInfo, data),
    uploadImage: (data) => Request.file(`${address.uploadImage}?imgCategory=${data.imgCategory}`, data.form),

    //答題獲取出席證明
    getActivityQuestions: (data) => Request.post(address.getActivityQuestions, data),
    //檢查答題的答案是否正確
    checkActivityAnswer: (data) => Request.post(address.checkActivityAnswer, data),
    //获取我的问题卡
    getMyQuestionList: (data) => Request.post(address.getMyQuestionList, data),
    //获取问题卡详情
    queryQuestionBankItems: (data) => Request.post(address.queryQuestionBankItems, data),
    //获取问题答案
    getQuestionAnswer: (data) => Request.post(address.getQuestionAnswer, data),
    //记录复习进度
    recordSchedule: (data) => Request.post(address.recordSchedule, data),
    //恢复题目标识,错题,忽略题等
    recoverMark: (data) => Request.post(address.recoverMark, data),
    //完成答题
    completeLearn: (data) => Request.post(address.completeLearn, data),
    //重置学习记录
    resetLearnRecord: (data) => Request.post(address.resetLearnRecord, data),
    //查看已完成的题库复习记录
    queryCompletedLearnRecord: (data) => Request.post(address.queryCompletedLearnRecord, data),
}